import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupProfileAction } from '../markupProfile.action';
import { MarkupProfileTranslator } from '../markupProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const loadMarkupProfileListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupProfileAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getMarkupProfileList({}).pipe(
      mergeMap((response) => {
        const result = (response.markupProfiles ?? []).map(MarkupProfileTranslator.fromApi);

        return [
          MarkupProfileAction.loadList.done({ result }),
        ];
      }),
      catchApiError((error) => {
        return [
          MarkupProfileAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
